module.exports = __webpack_public_path__ + "img/user-Icon.c11b6f38.jpg";